"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _reactSlick = _interopRequireDefault(require("react-slick")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactSizeme = require("react-sizeme"),
    _Icon = _interopRequireDefault(require("../../Icon"));

require("../styles/_carousel.scss"), require("slick-carousel/slick/slick.css");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function PreviousArrow(a) {
  var b = a.onClick,
      c = a.className,
      d = a.currentItemIndex;
  return _react["default"].createElement("div", {
    onClick: b,
    className: (0, _classnames["default"])("carousel__left-arrow", c),
    role: "button",
    tabIndex: 0,
    onKeyPress: (0, _onEnterPressed["default"])({
      onClick: b
    })
  }, _react["default"].createElement(_Icon["default"], {
    name: "chevronleft",
    color: d ? "white" : "dusty",
    size: 20
  }));
}

function NextArrow(a) {
  var b = a.onClick,
      c = a.className,
      d = a.slidesToShow,
      e = a.currentItemIndex,
      f = a.childrenLength,
      g = void 0 === f ? 0 : f;
  return _react["default"].createElement("div", {
    onClick: b,
    className: (0, _classnames["default"])("carousel__right-arrow", c),
    role: "button",
    tabIndex: 0,
    onKeyPress: (0, _onEnterPressed["default"])({
      onClick: b
    })
  }, _react["default"].createElement(_Icon["default"], {
    name: "chevronright",
    color: e + d >= g ? "dusty" : "white",
    size: 20
  }));
}

var DEFAULT_CAROUSEL_CONFIG = {
  dots: !1,
  infinite: !1,
  speed: 500,
  responsive: [{
    breakpoint: 640,
    settings: {
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToScroll: 1
    }
  }]
};

function Carousel(a) {
  var b = a.children,
      c = a.config,
      d = a.itemWidth,
      e = a.slidesToShow;
  if (!b || !Array.isArray(b) || 1 === b.length) return b;

  var f = (0, _react.useState)(0),
      g = (0, _slicedToArray2["default"])(f, 2),
      h = g[0],
      i = g[1],
      j = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_CAROUSEL_CONFIG), c), {}, {
    beforeChange: function beforeChange(a, b) {
      i(b);
    }
  });

  return _react["default"].createElement(_reactSizeme.SizeMe, null, function (a) {
    var c = Math.floor,
        f = a.size,
        g = e || c(f.width / d);
    return j.nextArrow = _react["default"].createElement(NextArrow, {
      currentItemIndex: h,
      slidesToShow: g,
      childrenLength: b.length
    }), j.prevArrow = _react["default"].createElement(PreviousArrow, {
      currentItemIndex: h
    }), _react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({}, j, {
      slidesToShow: g,
      slidesToScroll: g
    }), b);
  });
}

var _default = (0, _react.memo)(Carousel);

exports["default"] = _default;